export const EVENT_NAMESPACE = 'HubSpotConversations';